import React, { useState, useEffect } from "react";
import Lottie from "lottie-react";
import { motion } from "framer-motion";
import coins from "./assets/coins.png";
import manLogo from "./assets/man-logo.png";
import manHatTip from "./assets/man-tip-hat.png";
import manMain from "./assets/man-full.png";
import ston from "./assets/stonfi.svg";
import tgLogo from "./assets/tg-logo.svg";
import copy from "./assets/copy.svg";
import tonCoin from "./assets/toncoin.png";
import xcom from "./assets/xcom.svg";
import dex from "./assets/dex.svg";
import gecko from "./assets/gecko.png";
import line1 from "./assets/line-1.png";
import line2 from "./assets/line-2.png";
import manVideo from "./assets/manvid.mp4";
import post1 from "./assets/post1.png";
import post2 from "./assets/post2.png";
import tgBg from "./assets/tg-bg.png"; // Importing background image
import { Toaster, toast } from "react-hot-toast";
import CommandmentsCarousel from "./CommandmentsCarousel";

export const fadeIn = {
  initial: { opacity: 0.15, scale: 1 },
  whileInView: { opacity: 1, scale: 1 },
  viewport: { once: false, amount: 0.3 },
  transition: { duration: 0.5 },
};

export const fadeUp = {
  initial: { opacity: 0.15, y: "10px" },
  whileInView: { opacity: 1, y: "0px" },
  viewport: { once: false, amount: 0.3 },
  transition: { duration: 0.8 },
};

function App() {
  const [dots, setDots] = useState(""); // State to control the dots animation
  const contractAddress = "EQB6Ql1JE7Hq0JuropLYschcu-WNt2vMmWF2-8mEMrK68nJn"; // Example contract address

  useEffect(() => {
    const interval = setInterval(() => {
      setDots((prev) => {
        if (prev.length === 3) {
          return ""; // Reset to no dots
        } else {
          return prev + "."; // Add one more dot
        }
      });
    }, 500); // Change dots every 500ms (half second)

    return () => clearInterval(interval); // Cleanup interval on component unmount
  }, []);

  const handleCopy = () => {
    navigator.clipboard.writeText(contractAddress);
    toast.success("Contract address copied!", {
      style: {
        padding: "16px",
      },
    });
  };

  const currentYear = new Date().getFullYear();

  return (
    <div className="relative flex flex-col items-center justify-start w-full h-[100vh] min-h-screen overflow-x-hidden">
      <Toaster position="top-right" reverseOrder={false} />
      <div className="relative bg-blue-gradient w-full pb-16 rounded-b-[40px] max-w-screen-2xl mx-auto">
        <div
          className="absolute inset-0 bg-black opacity-[2%] md:opacity-0 z-0"
          style={{
            backgroundImage: `url(${tgBg})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        ></div>

        <header className="relative w-full flex max-w-screen-lg justify-end z-10 p-6 mx-auto">
          {/* Animated logo */}
          {/* <motion.img
            className="text-4xl w-12 h-12"
            initial={{ y: -50 }}
            animate={{ y: 0 }}
            transition={{ type: "spring", stiffness: 150 }}
            src={manHatTip}
          /> */}

          <motion.a
            href="https://t.me/gentlemanton"
            target="_blank"
            className="flex items-center gap-1 px-3.5 py-2 md:px-5 md:py-3 text-md text-[#14A7FD] border border-[#45BBFF] font-normal bg-white hover:scale-[102%] transition ease-in-out duration-200 rounded-full"
          >
            Telegram <img className="h-7 w-7" src={tgLogo} />
          </motion.a>
        </header>
        {/* Wrapper for Hero Section */}
        <div className="relative w-full max-w-screen-md mx-auto flex flex-col md:justify-center md:items-center justify-center items-center md:my-10 px-6 z-10">
          {/* Hero Section */}

          <div className="flex flex-col justify-center items-center text-center md:w-1/2 mt-12 lg:mt-0">
            <div className="relative">
              <motion.div className="relative flex justify-center items-center w-[55%] lg:w-[70%] mx-auto max-w-xl md:mb-6">
                <img src={manMain} alt="Gentleman" />
              </motion.div>
            </div>
          </div>
          <div className="text-center text-white flex flex-col md:w-full mt-10 md:mt-0">
            <h2 className="uppercase">The Telegram Mascot Since 2014</h2>
            <h1 className="font-bold font-secondary text-[42px] md:text-7xl uppercase">
              Gentleman
            </h1>
          </div>
        </div>
        {/* buy and copy */}
        <div className="relative flex flex-col items-center w-full mt-8 px-6 mb-4 z-10">
          {/* Buy Button with hover scale animation */}
          <motion.a
            href="https://app.ston.fi/swap?chartVisible=false&ft=TON&tt=MAN"
            target="_blank"
            className="flex w-full justify-center md:max-w-xs cursor-pointer items-center gap-3 px-12 py-3.5 border text-white bg-[#34B0DF] border-white text-xl hover:saturate-150 transition ease-in-out duration-200 rounded-full font-semibold"
          >
            Buy $MAN <img className="h-5 w-5" src={ston} />
          </motion.a>

          {/* Copy Contract Button with hover rotation animation */}
          <motion.button
            className="flex items-center gap-2 px-4 py-2 mt-4 text-md font-medium text-white hover:text-white/90 hover:border-white/90 transition-all ease-in-out duration-150"
            onClick={handleCopy}
          >
            <span className="border-b border-white text-white rounded-sm">
              Copy Contract
            </span>
            <div className="relative">
              <motion.img
                src={copy}
                className="transition-transform ease-in-out duration-150 relative hover:translate-x-2 fill-[#45BBFF]"
                alt="copy icon"
              />
            </div>
          </motion.button>
        </div>
      </div>
      <motion.div
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 0.8, y: 0 }}
        transition={{ duration: 0.6 }}
        className="relative w-full flex md:hidden flex-col items-center bg-white gap-3 rounded-t-[40px] p-6 mt-10 max-w-screen-lg z-10 overflow-x-visible"
      >
        <motion.img
          src={line1}
          className="h-[130px] w-auto max-w-none relative"
          alt="Line graphic"
          animate={{ x: ["-700px", "700px", "-700px"] }}
          transition={{
            duration: 150,
            ease: "linear",
            repeat: Infinity,
            repeatType: "loop",
          }}
        />
        <motion.img
          src={line2}
          className="h-[130px] w-auto max-w-none relative"
          alt="Line graphic"
          animate={{ x: ["600px", "-600px", "600px"] }}
          transition={{
            duration: 162,
            ease: "linear",
            repeat: Infinity,
            repeatType: "loop",
          }}
        />
      </motion.div>
      <motion.div
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 0.8, y: 0 }}
        transition={{ duration: 0.6 }}
        className="relative w-full flex-col items-center bg-white gap-3 rounded-t-[40px] p-6 mt-10 max-w-screen-lg z-10 overflow-x-visible hidden md:flex"
      >
        <motion.img
          src={line1}
          className="h-[180px] w-auto max-w-none relative"
          alt="Line graphic"
          animate={{ x: ["-300px", "300px", "-300px"] }}
          transition={{
            duration: 150,
            ease: "linear",
            repeat: Infinity,
            repeatType: "loop",
          }}
        />
        <motion.img
          src={line2}
          className="h-[180px] w-auto max-w-none relative"
          alt="Line graphic"
          animate={{ x: ["200px", "-200px", "200px"] }}
          transition={{
            duration: 162,
            ease: "linear",
            repeat: Infinity,
            repeatType: "loop",
          }}
        />
      </motion.div>
      <div className="max-w-screen-lg mx-auto w-full text-black mt-10 p-6">
        {/* About Section */}
        <div className="mt-6 text-center">
          <p className="text-md uppercase text-[#14A7FD]">
            Origins of the Mascot
          </p>
          <h2 className="text-2xl font-bold mb-6 uppercase font-secondary text-[#14A7FD]">
            About Gentleman
          </h2>
          <p className="text-md">
            Gentleman is a young capitalist whos purpose serves to explain
            telegram’s functions. Character designed by Telegram’s Creative
            Director. He has been a stamp in the Telegram brand since 2014. He
            appears in official website blogs, social medias and even Telegram
            News! In addition plenty of lore to examine. One example is ……
            Gentleman seems to share his birthday with Pavel Durov’s (Telegram
            CEO) father.
          </p>
          <div className="flex flex-col gap-4">
            <span className="italic pt-4 text-lg">"Manners maketh man!"</span>
            <span className="font-secondary text-[#14A7FD]">– Gentleman</span>
          </div>
        </div>
        <div className="flex flex-col md:flex-wrap md:flex-row justify-center items-center gap-6 max-w-screen-lg mx-auto">
          <motion.div
            className="rounded-3xl border-2 shadow-lg border-gray-100 overflow-hidden mt-10 md:m-0 md:w-[30%]"
            {...fadeIn}
          >
            <video
              autoPlay
              muted
              loop
              className="scale-150 rounded md:max-h-[350px] w-full"
              src={manVideo}
            ></video>
          </motion.div>

          <motion.div
            className="rounded-3xl border-2 shadow-lg border-gray-100 overflow-hidden md:w-[30%]"
            {...fadeIn}
          >
            <img src={post2} className="w-full h-full object-cover" />
          </motion.div>

          <motion.div
            className="rounded-3xl border-2 shadow-lg border-gray-100 overflow-hidden md:w-[30%]"
            {...fadeIn}
          >
            <img className="scale-95 w-full h-full object-cover" src={post1} />
          </motion.div>

          <motion.p
            className="text-gray-400 font-sm text-center md:w-full mx-2 mt-1"
            {...fadeIn}
          >
            Gentleman is featured in the latest telegram blog posts!
          </motion.p>
        </div>
        {/* Combined Social and DexScreener/GeckoTerminal Links */}
        <div className="mt-24 text-center">
          <p className="text-md uppercase text-[#14A7FD]">Join Our Community</p>
          <h2 className="text-2xl font-bold mb-6 uppercase font-secondary text-[#14A7FD]">
            Socials & More
          </h2>
        </div>
        <div className="flex flex-wrap md:flex-row justify-center items-start gap-3 mt-6">
          {/* Social Links */}
          <a
            href="https://x.com/gentlemanonton"
            target="_blank"
            rel="noopener noreferrer"
            className="flex h-[60px] items-center gap-2 bg-black text-white px-8 py-4 rounded-xl hover:bg-blue-600 transition"
          >
            Twitter <img src={xcom} />
          </a>
          <a
            href="https://t.me/gentlemanton"
            target="_blank"
            rel="noopener noreferrer"
            className="flex h-[60px] items-center gap-2 bg-[#14A7FD] text-white px-8 py-4 rounded-xl hover:bg-blue-600 transition"
          >
            Telegram <img src={tgLogo} />
          </a>

          {/* DexScreener and GeckoTerminal Links */}
          <a
            href="https://www.geckoterminal.com/ton/pools/EQB91RhU3K-P2F8Rlkk12hv9zu6A76rBcvm7NOYmDN9f-8sg"
            target="_blank"
            rel="noopener noreferrer"
            className="flex h-[60px] items-center gap-2 bg-purple-800 text-white px-4 py-4  rounded-xl hover:bg-gray-300 transition"
          >
            GeckoTerminal <img className="h-8" src={gecko} />
          </a>
          <a
            href="https://dexscreener.com/ton/eqb91rhu3k-p2f8rlkk12hv9zu6a76rbcvm7noymdn9f-8sg"
            target="_blank"
            rel="noopener noreferrer"
            className="flex h-[60px] items-center gap-2 bg-black text-white px-4 py-4  rounded-xl hover:bg-gray-300 transition"
          >
            DexScreener <img className="h-7" src={dex} />
          </a>
        </div>
      </div>

      <div className="w-full flex h-fit">
        <CommandmentsCarousel />
      </div>

      <div className="my-28 text-center px-6 max-w-screen-md">
        <h2 className="text-2xl font-bold mb-6 md:mb-12 uppercase font-secondary text-[#14A7FD]">
          How to Buy
        </h2>

        <div className="text-left space-y-8">
          {/* Step 1 */}
          <motion.div {...fadeUp}>
            <p className="text-xl font-bold text-[#14A7FD]">
              1. Create a Wallet
            </p>
            <p className="text-md text-gray-700">
              Download the{" "}
              <a
                href="https://tonkeeper.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#14A7FD] underline"
              >
                Tonkeeper
              </a>{" "}
              wallet extension and set it up to create your wallet.
            </p>
          </motion.div>

          {/* Step 2 */}
          <motion.div {...fadeUp}>
            <p className="text-xl font-bold text-[#14A7FD]">2. Get Some TON</p>
            <p className="text-md text-gray-700">
              Make sure you have TON in your wallet to swap for $MAN. If you
              don’t have any TON, you can buy it directly on{" "}
              <a
                href="https://www.bybit.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#14A7FD] underline"
              >
                Bybit
              </a>
              ,{" "}
              <a
                href="https://www.okx.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#14A7FD] underline"
              >
                OKX
              </a>
              , transfer from another wallet, or buy on another exchange and
              send it to your Tonkeeper wallet.
            </p>
          </motion.div>

          {/* Step 3 */}
          <motion.div {...fadeUp}>
            <p className="text-xl font-bold text-[#14A7FD]">3. Go to Ston.fi</p>
            <p className="text-md text-gray-700">
              Visit{" "}
              <a
                href="https://ston.fi"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#14A7FD] underline"
              >
                Ston.fi
              </a>{" "}
              in Google Chrome. Connect your Tonkeeper wallet, paste the $MAN
              token address into Ston.fi, select $MAN, and confirm. When
              Tonkeeper prompts you for a wallet signature, sign it to complete
              the process.
            </p>
          </motion.div>

          {/* Step 4 */}
          <motion.div {...fadeUp}>
            <p className="text-xl font-bold text-[#14A7FD]">
              4. Switch TON for $MAN
            </p>
            <p className="text-md text-gray-700">
              Swap your TON for $MAN. We have ZERO taxes, so you don’t need to
              worry about slippage unless there is significant market
              volatility.
            </p>
          </motion.div>
        </div>
      </div>

      {/* Footer */}
      <footer className="w-full bg-white text-gray-600 text-center p-4 mb-16">
        <p className="text-sm">© {currentYear} Gentleman Token $MAN on $TON</p>
      </footer>
    </div>
  );
}

export default App;
